import { Box, IconButton, Menu, Typography } from '@mui/material'
// import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import React from 'react'
import useStyles from './useStyles'
// import { useNavigate } from 'react-router-dom'

import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined'

export default function ModalMenuItem ({ item, setLoading, onDesbloquear }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />
      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          onDesbloquear={onDesbloquear}
        />
      </Menu>
    </>
  )
}

function FiltersList ({ item, onClose, onDesbloquear }) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        height: 40,
        width: 200
      }}
      className={classes.boxStyle}
    >
      {/* <IconButton
        onClick={() => {
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton> */}
      <IconButton
        onClick={() => {
          onClose()
          onDesbloquear(item.personalLegalDeclarationId)
        }}
      >
        <Box className={classes.boxTypography}>
          <LockOpenOutlinedIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Desbloquear
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}
